<template>
	<div class="wrap">
		<DelData ref="delDatas"></DelData>
		<Cleardf @dataList="dataList" ref="clear"/>
		<Dfadd ref="addDf" :type="type" :name="name" :flag="getdata.flag" :id="getdata.id" @closeWin="closeWin" :dialogVisible="dialogVisible"></Dfadd>
		<Addmore 
			:moreAddwin="moreAddwin" 
			downloadName="党员信息表" 
			title="批量新增党费" 
			@downExcel="downExcel" 
			@closeMorewin="closeMorewin"
			@pushData="pushData"></Addmore>
		<div class="navbar">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item>党务管理</el-breadcrumb-item>
				<el-breadcrumb-item>{{$route.name}}</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="datawrap">
			<div class="treeWrap" v-if="$store.state.user.userinfo.flag!=3">
				<tree @treeSelect="treeSelect"></tree>
			</div>
			<div class="datatable">
				<div class="datas">
					<div class="selectbar">
						<div>
							<el-input
								style="margin-right: 10px;width: 200px;"
								placeholder="请输入内容"
								size="small"
								prefix-icon="el-icon-search"
								v-model="getdata.name"
								@input="getdata.page = 1;totalPage = 0;dataList();">
							</el-input>
							<el-select
								size="small"
								style="margin-right: 10px;width: 120px !important;" 
								v-model="getdata.year" placeholder="请选择年份"
								@change="getdata.page = 1;totalPage = 0;dataList();"
								clearable>
								<el-option
									:key="index"
									v-for="(item,index) in $yearList()"
									:label="item"
									:value="item">
								</el-option>
							</el-select>
						</div>
						<div>
							<el-button type="primary" size="small" v-if='$store.state.user.userinfo.flag == 1' @click="pubTixing">一键提醒</el-button>
							<el-button type="primary" size="small" v-if='$store.state.user.userinfo.flag == 3' @click="dialogVisible=true;type='add';name='single'">新增</el-button>
							<el-button type="primary" size="small" v-if='$store.state.user.userinfo.flag == 3' @click="moreAddwin=true;">批量新增</el-button>
							<el-button type="primary" size="small" @click="daochu">导出表格</el-button>
						</div>
					</div>
					<div class="selectdata">
						<myTables 
							:tableData="tableData"
							delkey="id"
							:tableHeader="tableHeader"
							:loading="true" 
							:indexs="false"
							:selection="$store.state.user.userinfo.flag==3?true:false">
						</myTables>
						<Page :totalPage="totalPage" :pageSize="10" @changedata="changedata"></Page>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import tree from '@/components/tree.vue'
	import { dwgl,dyjy } from '@/axios'
	import Page from '@/components/page.vue'
	import { Message } from 'element-ui'
	import Cleardf from './components/cleardf.vue'
	import Dfadd from './components/dftj.vue'
	import Addmore from '@/components/moreadd.vue'
	import myTables from '@/components/tables/tables.vue'
	import DelData from '@/components/delToast.vue'
	let that;
	export default{
		data(){
			return{
				getdata:{
					id: this.$store.state.user.userinfo.id,
					flag: this.$store.state.user.userinfo.flag,
					name: "",
					year: "",
					sign: 6,
					page: 1
				},
				delList:[],
				moreAddwin:false,
				type:'add',
				name : 'single',
				dialogVisible:false,//新增弹窗
				tableData:[],
				totalPage:0,
				tableHeader: [
				]
			}
		},
		components:{tree,Page,Dfadd,Addmore,myTables,DelData,Cleardf},
		created(){that = this;},
		methods:{
			// 关闭新增或编辑弹窗
			closeWin(){
				this.dialogVisible = false;
				this.dataList();
			},
			// 关闭批量新增弹窗
			closeMorewin(){
				this.moreAddwin = false;
				this.dataList();
			},
			// 下载批量表格
			downExcel(){
				dwgl.exportPartyOrgan({
					user_id:that.getdata.id,
					flag:that.getdata.flag,
					sign:10
				})
			},
			pubTixing(){
				// 一键提醒
				dyjy.sendOversee({
					dwid:that.$store.state.user.userinfo.dwid,
					zbid:that.$store.state.user.userinfo.id,
					type:6,//党费统计，
					flag:that.$store.state.user.userinfo.flag,
				}).then(res => {
					if(res.code == 200){
						Message.success(res.msg)
					}else{
						Message.error(res.msg)
					}
				})
			},
			// 批量上传数据提交
			pushData(value){
				dwgl.excelPutData({
					uid:that.getdata.id,
					sign:2,
					url:value.src
				}).then(res => {
					if(res == 200){
						that.closeMorewin();
					}
				})
			},
			// 数据
			dataList(){
				that.tableHeader = [];
				let tableHeader = [
					// 表头
					{prop: 'u_name', label: '姓名',width:'90',fixed:'left'},
					{prop: 'cy_zz', label: '所属组织',width:''},
					{prop: "year", label: '1月',width:'50',formatData:(val) => {
						return val[0]
					}},
					{prop: 'year', label: '2月',width:'50',formatData:(val) => {
						return val[1]
					}},
					{prop: 'year', label: '3月',width:'50',formatData:(val) => {
						return val[2]
					}},
					{prop: 'year', label: '4月',width:'50',formatData:(val) => {
						return val[3]
					}},
					{prop: 'year', label: '5月',width:'50',formatData:(val) => {
						return val[4]
					}},
					{prop: 'year', label: '6月',width:'50',formatData:(val) => {
						return val[5]
					}},
					{prop: 'year', label: '7月',width:'50',formatData:(val) => {
						return val[6]
					}},
					{prop: 'year', label: '8月',width:'50',formatData:(val) => {
						return val[7]
					}},
					{prop: 'year', label: '9月',width:'50',formatData:(val) => {
						return val[8]
					}},
					{prop: 'year', label: '10月',width:'60',formatData:(val) => {
						return val[9]
					}},
					{prop: 'year', label: '11月',width:'60',formatData:(val) => {
						return val[10]
					}},
					{prop: 'year', label: '12月',width:'60',formatData:(val) => {
						return val[11]
					}},
				]
				let controlBar = {
					prop: 'oper', label: '操作', fixed: 'right', width: '114',align:'center',show:this.$store.state.user.userinfo.flag==3,
					oper: [
						{name: '编辑', style: {color:'#bb0000'}, clickFun: this.editData,show:true},
						{name: '清空', style: {color:'#bb0000'}, clickFun: this.clear,show:true},
					]
				}
				if(that.$store.state.user.userinfo.flag == 3){
					that.tableHeader = tableHeader.concat(controlBar)
				}else{
					that.tableHeader = tableHeader
				}
				dwgl.dftj(that.getdata).then(res => {
					if(res.data.pagedata){
						res.data.pagedata.forEach(item => {
							item.year = Object.values(item.year)
						})
						that.tableData = res.data.pagedata;
					}
					that.totalPage = res.data.count;
				})
			},
			// 分页查询
			changedata(current){
				that.getdata.page = current;
				that.dataList();
			},
			// 树形结构筛选
			treeSelect(data){
				that.getdata.id = data.id;
				that.getdata.flag = data.flag;
				that.getdata.page = 1;
				that.dataList();
			},
			// 编辑
			editData(data){
				that.type = 'edit';
				that.dialogVisible = true;
				that.name = 'single';
				that.$refs.addDf.bindData(data)
			},
			// 清空
			clear(data){
				this.$refs.clear.openWin(data.id, this.getdata.year)
			},
			// 导出表格
			daochu(){
				if(that.tableData.length != 0){
					dwgl.exportPartyOrgan(that.getdata);
				}else{
					Message({
						type:"warning",
						message:"暂无可导出的数据"
					})
				}
			}
		},
		mounted() {
			that.dataList();
		}
	}
</script>

<style lang="scss">
	.wrap{
		position: relative;
		height: 100%;
		width: 100%;
		.fengmian {
		    height: 86px;
		    width: 138px;
		    margin: 10px 16px 10px 14px;
		}
	}
</style>

